import isMobile from '../../services/mobile';
import createReducer from '../../utils/createReducer';

export const MOBILE = 'MOBILE';

export default createReducer({
  [MOBILE]: (_, { mobile }) => !!mobile
}, isMobile());

export const mobileAction = mobile => ({ type: MOBILE, mobile });
